module.exports = __webpack_public_path__ + "static/media/meter3.74429fc6.gif";